// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__35szf","subheader":"ReorderModal_subheader__Hf9_z","listWrap":"ReorderModal_listWrap__1dCAs"};